var map = {
	"./images/richard.jpg": 1747
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1746;


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/team ^.*\/richard\.jpg$
// module id = 1746
// module chunks = 146